/**
 * SearchBar.tsx — søkefelt med ikon
 *
 * Ren React-komponent stylet med Carbon design-tokens.
 * Bruker eget SearchIcon fra src/components/icons/.
 *
 * Bruk:
 *   <SearchBar value={query} onChange={setQuery} placeholder="Søk brukere…" />
 */

import { ChangeEvent } from 'react';
import { SearchIcon } from '@/components/icons';
import styles from './search-bar.module.css';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  ariaLabel?: string;
}

export default function SearchBar({
  value,
  onChange,
  placeholder = 'Søk…',
  ariaLabel = 'Søk',
}: SearchBarProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className={styles.wrapper}>
      <SearchIcon size={16} className={styles.icon} />
      <input
        type="search"
        className={styles.input}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        aria-label={ariaLabel}
      />
    </div>
  );
}
